
import { defineComponent, ref, onMounted } from 'vue';

import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';

import { makePath } from './utils/routing';
import { currentView } from './routes';

const currentPath = ref(makePath(window.location.pathname));

function setup() {
	onMounted(() => {
		window.addEventListener('hashchange', () => {
			const path = makePath(window.location.pathname);
			if (path === currentPath.value) return;
			currentPath.value = path;
		});
	});
}

export default defineComponent({
	name: 'App',
	computed: {
		currentView: () => currentView(currentPath.value),
	},
	setup,
	components: {
		AppHeader,
		AppFooter,
	},
});
